import { IReportRepository } from './IReportRepository';
import type BaseApiProvider from 'providers/BaseApiProvider';
import { injectable, inject } from 'inversify';
import Logger from 'utilities/log';
import { SystemLogModel, SystemLogPayloadFilterModel } from 'models/report/systemLog';
import { PaginationModel, PaginationPayloadModel } from 'models/PaginationModel';
import { ApiResponseModel } from 'models/ApiResponseModel';

@injectable()
class ReportRepository implements IReportRepository {

    @inject(Symbol.for("BaseApiProvider_9097")) private _provider?: BaseApiProvider;

    public async Order_DailyReoirt(orderDate: string): Promise<any> {
        try {
            const url = `/StimulSoft/Viewer?id=464e8c40-023a-417f-b499-cabba0fc18a3&orderDate=${orderDate}`;
            return await this._provider!.get(url);
        } catch (error) {
            Logger.event('API_RESPONSE_ERROR', `Failed to get item request list: ${error}`);
            throw new Error(`Failed to get item request list: ${error}`);
        }
    }

    public async GetAllLogs(params: PaginationPayloadModel<SystemLogPayloadFilterModel>): Promise<{
        rows: SystemLogModel[];
        pagination: PaginationModel;
    } | null> {
        try {
            const url = `Log/info/GetAllLogs`;
            const response = await this._provider!.post(url, params);
            const res = ApiResponseModel.fromJson(response);

            if (!res.status) {
                Logger.event('API_RESPONSE_ERROR', res.error || 'Failed to get product list');
                return {
                    rows: [],
                    pagination: PaginationModel.empty()
                };
            }

            return {
                rows: (response["data"]["rows"] as any[]).map(SystemLogModel.fromJson),
                pagination: PaginationModel.fromJson(response["data"])
            };
        } catch (error) {
            Logger.event('API_RESPONSE_ERROR', `Failed to GetAllLogs: ${error}`);
            throw new Error(`Failed to GetAllLogs: ${error}`);
        }
    }


    public async SetLog(FormId: number): Promise<ApiResponseModel> {
        try {
            const url = `Log/Action/SetLog`;
            const formData = new FormData();
            formData.append('FormId', FormId.toString());
            const response = await this._provider!.postForm(url, formData);
            return ApiResponseModel.fromJson(response);
        } catch (error) {
            Logger.event('API_RESPONSE_ERROR', `Failed to SetLog: ${error}`);
            throw new Error(`Failed to SetLog: ${error}`);
        }
    }

}

export default ReportRepository;
